import { useState } from 'react'
import * as Sentry from '@sentry/react'
import { useGetIntegrationConnectUrlMutation } from '@sketch/gql-types'
import { useToast } from '@sketch/toasts'

export const useGetConnectIntegrationUrl = () => {
  const { showToast } = useToast()
  const [isPersistentLoading, setIsPersistentLoading] = useState(false)

  const [getIntegrationConnectUrl] = useGetIntegrationConnectUrlMutation({
    onCompleted: data => {
      const { url } = data.getIntegrationConnectUrl

      window.location.href = url
    },
    onError: ({ message }) => {
      setIsPersistentLoading(false)
      showToast('Something went wrong', 'negative')

      Sentry.captureMessage(`Integration Connect URL Error: ${message}`)
    },
  })

  const handleGetIntegrationConnectUrl = (
    ...args: Parameters<typeof getIntegrationConnectUrl>
  ) => {
    setIsPersistentLoading(true)

    return getIntegrationConnectUrl(...args)
  }

  return {
    getIntegrationConnectUrl: handleGetIntegrationConnectUrl,
    loading: isPersistentLoading,
  }
}
